import { render, staticRenderFns } from "./SystemParam.vue?vue&type=template&id=74d0728a&scoped=true&"
import script from "./SystemParam.vue?vue&type=script&lang=js&"
export * from "./SystemParam.vue?vue&type=script&lang=js&"
import style0 from "./SystemParam.vue?vue&type=style&index=0&id=74d0728a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d0728a",
  null
  
)

export default component.exports